import {
  UIRouterReact,
  pushStateLocationPlugin,
  servicesPlugin
} from "@uirouter/react";

import { requireStates } from "util";
import Layout from "components/support/layout";

const initialStates = [
  {
    name: "app",
    abstract: true,
    component: Layout
  }
];

const context = require.context(
  "./components/app/",
  true,
  /\.\/[^/]+\/index\.jsx?$/
);
const states = requireStates(context, initialStates);

const router = new UIRouterReact();
router.plugin(servicesPlugin);
router.plugin(pushStateLocationPlugin);
states.forEach(state => router.stateRegistry.register(state));
router.urlRouter.otherwise("/nao-encontrado");
export { router };



// WEBPACK FOOTER //
// ./src/router.js